import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { supportedLngs } from "./config";

import enTranslation from "../locales/en/translation.json";
import frTranslation from "../locales/fr/translation.json";
import ptTranslation from "../locales/pt/translation.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: enTranslation },
            fr: { translation: frTranslation },
            pt: { translation: ptTranslation }
        },
        supportedLngs: Object.keys(supportedLngs),
        fallbackLng: "fr",
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
